import {Modal} from 'react-bootstrap'
import {ID} from '../../../helpers'
import {CreateProjectAndClientModalContent} from './CreateProjectAndClientModalContent'

type Props = {
  show: boolean
  handleClose: () => void | undefined
  /** Quando informado, é chamado após criar o projeto (ex.: vincular em integrações). */
  onCreated?: (projectId: number, projectName: string) => void
  /** Nome inicial do projeto (ex.: texto digitado no select creatable). */
  initialProjectName?: string
}

const CreateProjectAndClient: React.FC<Props> = ({show, handleClose, onCreated, initialProjectName}) => {
  return (
    //@ts-ignore
    <Modal className='px-md-5 bg-glass' id='kt_modal_project_and_client'  tabIndex={-1} role='dialog' show={show}
      dialogClassName='mw-500px modal-dialog-centered' aria-hidden='true' backdrop='static' onHide={handleClose} >
      <CreateProjectAndClientModalContent
        handleClose={handleClose}
        onCreated={onCreated}
        initialProjectName={initialProjectName}
      />
    </Modal>
  )
}

export {CreateProjectAndClient}